import React from "react";
import UserEdit from "../../components/UserEdit/UserEdit";
import UserPage from "../../common/UserPage/UserPage";
import Footer from "../../common/Footer/Footer";
import { useSelector } from "react-redux"

function UserEditPage() {
  const { currentUser } = useSelector((state) => state.users);

  return (
    <div>
      <UserPage customImage={currentUser?.picture} />
      <UserEdit />
      <Footer />
    </div>
  );
}

export default UserEditPage;
